<div style="position: relative;">
    <app-drop-menu [menu]="dropMenu" (action)="clickedAction($event)"></app-drop-menu>
    <!-- arrow -->
    <div style="position: absolute; top: 50%;height: 12px; right: 0;width: 100%; display:flex;flex-direction: row;justify-content: space-between;padding: 0px 4px 0px 4px">
        <i class="fa-solid fa-circle-chevron-left arrow-icon carousel-arrow-left" (click)="left()"></i>
        <i class="fa-solid fa-circle-chevron-right arrow-icon carousel-arrow-right" (click)="right()"></i>
    </div>
    <img class="carousel-image" (error)='onItemError($event)' [src]="getCurrentImage()" width="125" height="125">
</div>
